function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        stroke: #000;\n        stroke-width: 1px;\n        fill-rule: evenodd;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "f_faceshape_long_vector-2",
  "data-name": "f_faceshape_long_vector",
  className: "cls-2",
  d: "M507,302c8.243-.718,10.528-0.347,16,3,7.467,21.366-4.952,50.538-19,60-4.294,2.893-7.985,1.8-11,6q-7,21-14,42c-7.5,13.159-22.314,26.235-28,39-7.309,16.41,4.226,42.658,0,58l-1,2c-7.573,14.752-25.52,22.881-36,35l-15,29-2-1c-8.5-27.217-31.1-47.77-50-65,2.718-17,6.315-44.367,0-62l-16-19c-11.672-17.178-19.721-37.269-26-60-20.441-7.142-55.7-70.626-14-67-1.309-79.145,28.707-121.841,95-134,20.566-3.772,47.957.327,63,9C488.234,199.619,507.749,238.732,507,302Z"
});

var SvgFFaceshapeLongVector = function SvgFFaceshapeLongVector(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f_faceshape_long_vector",
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFFaceshapeLongVector, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/f_faceshape_long_vector.2eaa65b6.svg";
export { ForwardRef as ReactComponent };